//Keydown numbers
export const keyCodes = {
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
};

//Outline focus styling state
const outlineStylingActive = true;

export const isOutlineStylingActive = () => outlineStylingActive;

export const mimicLoading = async (timeout = 2000) => {
    try {
        return await new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, timeout);
        });
    } catch (e) {
        console.error(e);
    }
};

export const validateEmail = value => {
    // eslint-disable-next-line
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
        value
    );
};

export const isIE = () => navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

export const focusableElements =
    'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    
export const releasedAssetsPath = () => {
    const resourcePath = [...document.querySelectorAll('link')]
        .map(node => node.href)
        .find(href => href.includes('releasedAssets'));
    const releasedAssetsPath = resourcePath && `${resourcePath.split('releasedAssets')[0]}releasedAssets/`;
    return releasedAssetsPath;
};
